import { render, staticRenderFns } from "./modification-status.vue?vue&type=template&id=38e736b2&"
import script from "./modification-status.vue?vue&type=script&lang=js&"
export * from "./modification-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports